<app-page-header title="PSP Setting" subtitle="Configure settings and parameters for payment providers">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="settings"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['key', 'value', 'pspType']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="key" class="text-left">
                    <div class="flex items-center gap-2">
                        Key
                        <p-sortIcon field="key"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="key" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="value" class="text-left">
                    <div class="flex items-center gap-2">
                        Value
                        <p-sortIcon field="value"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="value" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType" class="text-left">
                    <div class="flex items-center gap-2">
                        PSP Type
                        <p-sortIcon field="pspType"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType" display="menu"></app-column-filter>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.key }}</td>
                <td>{{ row.value }}</td>
                <td>{{ row.pspType }}</td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Setting' : 'New Setting'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
>
    <form [formGroup]="settingForm" (ngSubmit)="saveSetting()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Key *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter key"
                    formControlName="key"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('key') }"
                />
                @if (isInvalid('key')) {
                    <small class="text-red-500">Key is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Value *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter value"
                    formControlName="value"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('value') }"
                />
                @if (isInvalid('value')) {
                    <small class="text-red-500">Value is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">PSP Type *</label>
                <p-select
                    [options]="pspTypes"
                    formControlName="pspTypeId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select PSP type"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('pspTypeId') }"
                ></p-select>
                @if (isInvalid('pspTypeId')) {
                    <small class="text-red-500">PSP type is required.</small>
                }
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveSetting()"></p-button>
        </div>
    </ng-template>
</p-dialog>
